// ! ATTENTION ! NE PAS TOUCHER ! Le script powershell 'Update-App-Version.ps1' modifie automatiquement le contenu de ce fichier lors de la build

const appVersion: string = '2.1.13-alpha.14';
